<template id="story">
	<div class="page page-story">
		<page-top></page-top>
		<div class="page-content">
			
			<div class="left">
				<div class="heading">EPISODE</div>
				<div class="nav">
					<div class="nav-item" v-for="story in storys" v-on:click="switchStory(story)">
						<div class="picture">
							<div class="box">
								<img v-bind:src="story.nav_img" class="bg" v-if="story.nav_img">
								<div class="placeholder" v-if="!story.nav_img">COMING<br>SOON</div>
							</div>
						</div>
						<div class="title">
							<a>&gt;&nbsp;{{story.nav_title}}</a>
						</div>
						
					</div>
				</div>
			</div>
			<div class="right">
				
				<div class="intro">
					<div class="">

						<div class="title"><div class="box">{{story.title}}</div></div>
						
						<div class="preview">
							<div class="placeholder box" v-if="!preview"></div>
							<img v-bind:src="preview" v-if="preview">
						</div>
						<div class="imgs">
							<img v-bind:src="img.url" v-for="img in story.imgs" v-on:click="switchPreview(img.url)">
						</div>
						<div class="content">
							<div class="box" v-html="story.content"></div>
						</div>
					</div>
				</div>
				
			</div>
		
		</div>
		
		<page-bottom></page-bottom>
	</div>
</template>

<script>
import $ from 'jquery'
export default {
	beforeUpdate: function() {
		
	},
	updated: function() {

		
	},
	data: function() {
		return {
			story: {},
			preview: '',
			storys: global.storys || []
		}
	},
	created: function() {
		
		
		if (!this.storys.length) {
			this.axios.get('/story/getList').then((response) => {
				
				for (let k in response.data) {
					if (response.data[k].imgs) {
						response.data[k].imgs = JSON.parse(response.data[k].imgs)
					} else {
						response.data[k].imgs = []
					}
					
				}
				console.log(response.data)
				let data = response.data
				this.storys = data
				this.story = this.storys[0];
				this.preview = this.story.imgs[0].url;
				global.storys = data
			})
		} else {
			this.story = this.storys[0];
			this.preview = this.story.imgs[0].url;
		}
	},
	methods: {
		switchStory: function(story) {


			var intro = $('#app .intro');
			var title = intro.find('.title');
			var thisVue = this;

			intro.stop();
			intro.animate({
				opacity: 0,
				top: '1000px'
			}, 400, function() {

				thisVue.story = story;
				if (thisVue.story.imgs && thisVue.story.imgs.length) {
					thisVue.preview = thisVue.story.imgs[0].url;
				} else {
					thisVue.preview = null
				}
				intro.css({
					top: 0,
					left: '1000px',
					opacity: 0
				});
				title.css({
					width: 0,
					height: 3
				});
				intro.animate({
					left: '0px',
					opacity: 1
				}, 400, function() {
					title.animate({
						width: 840,
					}, 600, function() {
						title.animate({
							height: 84,
						}, 600)
					});
				})
			});
			
		},
		switchPreview: function(src) {
			$('#app .preview').hide();
			this.preview = src;
			$('#app .preview').fadeIn(400)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Story.vue